<template>
  <pdl-button
    class="customization-send-to-retailer-button"
    qaid="send-to-retailer-button"
    primary
    block
    :disabled="isProcessingCustomizationAction"
    @click="initiateSubmitToRetailer"
  >
    {{ $t('projectOne.config.summary.sendRetailer') }}
  </pdl-button>
</template>

<script>
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import {PdlButton} from '@pedal/pdl-button';
import {SUMMARY_DIALOG_VIEWS} from '@/familyDetailsPage/store/bike-customization';
import {PdlToastType} from '@/constants/pdl-toast-type';

export default {
  name: 'CustomizationSubmitToRetailerButton',
  components: {PdlButton},
  computed: {
    ...mapState('bikeCustomization', [
      'buildId',
      'queuedShareAction',
      'bikeData',
      'hasSavedBuildAndUpdatedRoute',
      'hasQueuedSubmitToRetailerAction',
      'isCustomizationSummaryDialogOpen',
      'isSavedByUser',
      'isProcessingCustomizationAction',
    ]),
    ...mapState('backend', ['b2b', 'isUserLoggedIn', 'isConsumerFriendlyMode']),
    ...mapGetters('bikeCustomization', ['isBikeEditable', 'hasBikeBeenSubmittedToRetailer', 'isSavedBuild']),
  },
  watch: {
    hasSavedBuildAndUpdatedRoute(newState) {
      if (newState && this.hasQueuedSubmitToRetailerAction && this.isSavedByUser) {
        if (this.isCustomizationSummaryDialogOpen) {
          this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.SUBMIT_TO_RETAILER);
        } else {
          setTimeout(() => {
            this.setIsSubmitToRetailerDialogOpen(true);
          }, 500);
        }
      }
    },
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setIsSaveDialogVisible',
      'setHasQueuedSaveAction',
      'setCachedBuildData',
      'setIsSubmitToRetailerDialogOpen',
      'setHasQueuedSubmitToRetailerAction',
      'setSummaryDialogView',
      'setReopenPreviouslyOpenDialog',
      'setIsProcessingCustomizationAction',
    ]),
    ...mapActions('bikeCustomization', ['saveConfig']),

    async initiateSubmitToRetailer() {
      if (!this.isUserLoggedIn) {
        this.setReopenPreviouslyOpenDialog(true);
        this.setIsProcessingCustomizationAction(true);
        this.setCachedBuildData();
        this.setHasQueuedSaveAction(true);
        this.setHasQueuedSubmitToRetailerAction(true);
        await this.$nextTick();
        window.location.href = '/login/';
        return;
      }

      if (!this.isSavedBuild || this.hasBikeBeenSubmittedToRetailer) {
        this.queueSubmitActionAndPromptSave();
        return;
      }

      if (this.isSavedBuild && !this.isSavedByUser) {
        this.setHasQueuedSubmitToRetailerAction(true);
        await this.checkIfBuildBelongsToUserBySaving();
        return;
      }

      if (this.isSavedByUser && !this.hasBikeBeenSubmittedToRetailer) {
        if (this.isCustomizationSummaryDialogOpen) {
          this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.SUBMIT_TO_RETAILER);
        } else {
          return this.setIsSubmitToRetailerDialogOpen(true);
        }
      }
    },

    queueSubmitActionAndPromptSave() {
      this.setHasQueuedSubmitToRetailerAction(true);
      if (this.isCustomizationSummaryDialogOpen) {
        this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.SAVE_BUILD);
      } else {
        this.setIsSaveDialogVisible(true);
      }
    },

    async checkIfBuildBelongsToUserBySaving() {
      try {
        this.setIsProcessingCustomizationAction(true);
        await this.saveConfig();
      } catch (error) {
        console.error(error);
        this.$notify({
          type: PdlToastType.ERROR,
          message: this.$t('errorMessage.unableToProcess'),
        });
      } finally {
        this.setIsProcessingCustomizationAction(false);
      }
    },
  },
};
</script>
